/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { EssModalCustomElement } from 'app/shared/elements/ess-dialog';
import { openHouseholdCaseSummary } from 'app/cm/components/summary/household-case-summary';
import * as Core from 'app/core/models/essette-api';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class HouseholdCaseRibbon extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.twoWay })
    protected householdCase: CM.HouseholdCase | null = null;

    protected openHouseholdCaseSummary = openHouseholdCaseSummary;

    // Permissions
    protected hasHouseholdCaseRoute = false;
    protected showHouseholdCaseSummaryLink: boolean = false;
    protected canEditHouseholdCaseAssignment: boolean = false;
    protected canEditHouseholdCaseStatus: boolean = false;

    // Lookups
    protected statuses: CM.HouseholdCaseStatus[] = [];
    protected users: Core.User[] = [];


    ////****************** Element References ***************************************////
    protected $assignmentModal!: EssModalCustomElement;
    protected $statusModal!: EssModalCustomElement;
    protected $assignmentForm!: IForm;
    protected $statusForm!: IForm;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        if(!this.householdCase || !this.householdCase.id) { throw new Error('Missing bindable property [householdCase]'); }
        this.checkPermissions();
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.hasHouseholdCaseRoute = this.accountContext.hasRouteAccess('cm.household-case');
        this.showHouseholdCaseSummaryLink = this.accountContext.hasRouteAccess('cm.household-case.summary');
        this.canEditHouseholdCaseAssignment = this.accountContext.hasPermission('CM.HouseholdCase.Reassign');
        this.canEditHouseholdCaseStatus = this.accountContext.hasPermission('CM.HouseholdCase.UpdateStatus');
    }

    protected closeAssignmentModal(): void {
        this.$assignmentModal.close();
        if(this.$assignmentForm.reset) {
            this.$assignmentForm.reset();
        }
    }

    protected closeStatusModal(): void {
        this.$statusModal.close();
        if(this.$statusForm.reset) {
            this.$statusForm.reset();
        }
    }


    ////****************** Service Calls ********************************************////


}
